import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import {
  AssessmentReportAttempt,
  AssessmentReportPdfData,
} from "../../../../../services/api/types/reports/reports";
import { PackageType } from "../../../../../services/api/types/assignments/assignment";

interface ExportToExcelParams {
  attempts: AssessmentReportAttempt[];
  acknowledgementData?: AssessmentReportPdfData | null;
  packageType?: PackageType;
  reportName?: string;
  generatedBy?: string;
  time?: string;
  date?: string;
  fileName: string;
}

export const exportToExcel = ({
  attempts,
  acknowledgementData,
  packageType,
  reportName,
  generatedBy,
  time,
  date,
  fileName,
}: ExportToExcelParams) => {
  const infoSheetData: any[] = [
    ["Report type:", reportName || ""],
    ["Generated by:", generatedBy || ""],
    ["Date:", date || ""],
    ["Time:", time || ""],
  ];
  const infoSheet = XLSX.utils.aoa_to_sheet(infoSheetData);

  const isAckBased =
    packageType === PackageType.PdfUpload ||
    packageType === PackageType.VideoUpload;

  const rows: Record<string, any>[] = [];

  if (isAckBased) {
    rows.push({
      Acknowledged:
        acknowledgementData?.ackResponse === true
          ? "Yes"
          : acknowledgementData?.ackResponse === false
            ? "No"
            : "-",
      "Submitted at": acknowledgementData?.submittedAt
        ? dayjs(acknowledgementData.submittedAt).format("DD-MMM-YYYY HH:mm")
        : "-",
      Comment:
        acknowledgementData?.comment === "" ||
        acknowledgementData?.comment == null
          ? "-"
          : acknowledgementData.comment,
    });
  } else {
    attempts.forEach((attempt) => {
      attempt.questions.forEach((q) => {
        rows.push({
          Attempt: attempt.attemptNumber,
          "Start Date": attempt.started,
          "Last Accessed": attempt.lastAccessed,
          "Completion Date": attempt.completed,
          "Usage Time":
            attempt.timeSpent != null ? `${attempt.timeSpent} mins` : "-",
          "Lesson Status": attempt.status,
          Score: attempt.score == null ? "–" : attempt.score,
          Question: q.question ?? "-",
          "Date and Time": q.startDateTime,
          Response: q.userResponse ?? "-",
          Result: q.result === true ? "Correct" : "Incorrect",
        });
      });
    });
  }

  const dataSheet = XLSX.utils.json_to_sheet(rows);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, infoSheet, "Info");
  XLSX.utils.book_append_sheet(workbook, dataSheet, "Data");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `${fileName}.xlsx`);
};
